import { toOptions } from 'utils/toOptions';

import { useGetPoolMaintenanceTableData } from '../../../../Pools/PoolMaintenance/hooks/useGetPoolMaintenanceTableData';
import { useSelector } from 'hooks';

export const useGetPoolOptions = () => {
  const hasPoolOrganizationGrant = useSelector(
    (state) => state.grants.hasPoolsOrgGrant
  );
  const { data, ...getPoolMaintenanceTableData } =
    useGetPoolMaintenanceTableData({ enabled: hasPoolOrganizationGrant });

  return {
    ...getPoolMaintenanceTableData,
    data: toOptions(data ?? [], 'id', 'name')
  };
};
